import apiFetch from '../apiFetch'

export default function (values, token) {  
  return apiFetch({endPoint: `Pool/getObtenerNumeroPool`, method: 'GET', body: null, token:token})
}
